import PropTypes from "prop-types";
import React, { useState } from "react";
import TimeOffRequestDialog from "./TimeOffRequestDialog.jsx";

const TimeOffRequestType = (props) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleClickDialogOpen = () => {
    setIsDialogOpen(true);
  };

  const handleClickDialogClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    setIsDialogOpen(false);
  };

  return (
    <div data-testid="time-off-request-type-component">
      <span data-testid="time-off-request-type-text-link" className="text-link" onClick={handleClickDialogOpen}>
        {props.timeOffRequest.timeOffRequestType}
      </span>
      {isDialogOpen && (
        <TimeOffRequestDialog
          timeOffRequest={props.timeOffRequest}
          isDialogOpen={isDialogOpen}
          handleClickDialogOpen={handleClickDialogOpen}
          handleClickDialogClose={handleClickDialogClose}
          isAdminPage={props.isAdminPage}
          isDesktopView={props.isDesktopView}
        />
      )}
    </div>
  );
};

TimeOffRequestType.propTypes = {
  timeOffRequest: PropTypes.object.isRequired,
  isAdminPage: PropTypes.bool.isRequired,
  isDesktopView: PropTypes.bool.isRequired,
};

export default TimeOffRequestType;
